"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentDatePartsUTC = exports.useCurrentDateParts = exports.DateParts = void 0;

var _react = require("react");

var _utils = require("../utils");

var _types = require("./types");

var _DatePartEnum$YEAR, _DatePartEnum$MONTH, _DatePartEnum$DATE;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_DatePartEnum$YEAR = _types.DatePartEnum.YEAR;
_DatePartEnum$MONTH = _types.DatePartEnum.MONTH;
_DatePartEnum$DATE = _types.DatePartEnum.DATE;

/**
 * A class to handle all the date parts functions because the utils file was getting a bit out of control.
 */
var DateParts = // #### CONSTRUCTORS ####
function DateParts(_year, _month, _date) {
  var _this = this;

  _classCallCheck(this, DateParts);

  _defineProperty(this, _DatePartEnum$YEAR, void 0);

  _defineProperty(this, _DatePartEnum$MONTH, void 0);

  _defineProperty(this, _DatePartEnum$DATE, void 0);

  _defineProperty(this, "DEFAULT_DATE_FORMAT", "".concat(_types.DatePartFormatMap[_types.DatePartEnum.DATE], "/") + "".concat(_types.DatePartFormatMap[_types.DatePartEnum.MONTH], "/") + "".concat(_types.DatePartFormatMap[_types.DatePartEnum.YEAR]));

  _defineProperty(this, "isEqualTo", function (obj) {
    if (!(obj instanceof DateParts)) return false;

    if (!_this.isPartEqualTo(_types.DatePartEnum.YEAR, obj[_types.DatePartEnum.YEAR])) {
      return false;
    }

    if (!_this.isPartEqualTo(_types.DatePartEnum.MONTH, obj[_types.DatePartEnum.MONTH])) {
      return false;
    }

    if (!_this.isPartEqualTo(_types.DatePartEnum.DATE, obj[_types.DatePartEnum.DATE])) {
      return false;
    }

    return true;
  });

  _defineProperty(this, "isPartEqualTo", function (part, value) {
    var partValue = _this[part];
    if (partValue == null && value == null) return true;
    return partValue === (value != null ? value : null);
  });

  _defineProperty(this, "isGreaterThan", function (obj) {
    if (!(obj instanceof DateParts)) return false;

    if (_this[_types.DatePartEnum.YEAR] !== obj[_types.DatePartEnum.YEAR]) {
      return _this.isPartGreaterThan(_types.DatePartEnum.YEAR, obj[_types.DatePartEnum.YEAR]);
    }

    if (_this[_types.DatePartEnum.MONTH] !== obj[_types.DatePartEnum.MONTH]) {
      return _this.isPartGreaterThan(_types.DatePartEnum.MONTH, obj[_types.DatePartEnum.MONTH]);
    }

    if (_this[_types.DatePartEnum.DATE] !== obj[_types.DatePartEnum.DATE]) {
      return _this.isPartGreaterThan(_types.DatePartEnum.DATE, obj[_types.DatePartEnum.DATE]);
    }

    return false;
  });

  _defineProperty(this, "isPartGreaterThan", function (part, value) {
    var partValue = _this[part];
    if (partValue == null) return false;
    if (value == null) return true;
    return partValue > value;
  });

  _defineProperty(this, "isGreaterThanOrEqualTo", function (obj) {
    if (!(obj instanceof DateParts)) return false;

    if (_this[_types.DatePartEnum.YEAR] !== obj[_types.DatePartEnum.YEAR]) {
      return _this.isPartGreaterThanOrEqualTo(_types.DatePartEnum.YEAR, obj[_types.DatePartEnum.YEAR]);
    }

    if (_this[_types.DatePartEnum.MONTH] !== obj[_types.DatePartEnum.MONTH]) {
      return _this.isPartGreaterThanOrEqualTo(_types.DatePartEnum.MONTH, obj[_types.DatePartEnum.MONTH]);
    }

    if (_this[_types.DatePartEnum.DATE] !== obj[_types.DatePartEnum.DATE]) {
      return _this.isPartGreaterThanOrEqualTo(_types.DatePartEnum.DATE, obj[_types.DatePartEnum.DATE]);
    }

    return true;
  });

  _defineProperty(this, "isPartGreaterThanOrEqualTo", function (part, value) {
    if (_this.isPartEqualTo(part, value)) return true;
    return _this.isPartGreaterThan(part, value);
  });

  _defineProperty(this, "isLessThan", function (obj) {
    if (!(obj instanceof DateParts)) return false;

    if (_this[_types.DatePartEnum.YEAR] !== obj[_types.DatePartEnum.YEAR]) {
      return _this.isPartLessThan(_types.DatePartEnum.YEAR, obj[_types.DatePartEnum.YEAR]);
    }

    if (_this[_types.DatePartEnum.MONTH] !== obj[_types.DatePartEnum.MONTH]) {
      return _this.isPartLessThan(_types.DatePartEnum.MONTH, obj[_types.DatePartEnum.MONTH]);
    }

    if (_this[_types.DatePartEnum.DATE] !== obj[_types.DatePartEnum.DATE]) {
      return _this.isPartLessThan(_types.DatePartEnum.DATE, obj[_types.DatePartEnum.DATE]);
    }

    return false;
  });

  _defineProperty(this, "isPartLessThan", function (part, value) {
    var partValue = _this[part];
    if (partValue == null) return false;
    if (value == null) return true;
    return partValue < value;
  });

  _defineProperty(this, "isLessThanOrEqualTo", function (obj) {
    if (!(obj instanceof DateParts)) return false;

    if (_this[_types.DatePartEnum.YEAR] !== obj[_types.DatePartEnum.YEAR]) {
      return _this.isPartLessThan(_types.DatePartEnum.YEAR, obj[_types.DatePartEnum.YEAR]);
    }

    if (_this[_types.DatePartEnum.MONTH] !== obj[_types.DatePartEnum.MONTH]) {
      return _this.isPartLessThan(_types.DatePartEnum.MONTH, obj[_types.DatePartEnum.MONTH]);
    }

    if (_this[_types.DatePartEnum.DATE] !== obj[_types.DatePartEnum.DATE]) {
      return _this.isPartLessThan(_types.DatePartEnum.DATE, obj[_types.DatePartEnum.DATE]);
    }

    return true;
  });

  _defineProperty(this, "isPartLessThanOrEqualTo", function (part, value) {
    if (_this.isPartEqualTo(part, value)) return true;
    return _this.isPartLessThan(part, value);
  });

  _defineProperty(this, "toString", function () {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.DEFAULT_DATE_FORMAT;
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
    var datePartsString = format;
    var year = _this[_types.DatePartEnum.YEAR];
    var month = _this[_types.DatePartEnum.MONTH];
    var date = _this[_types.DatePartEnum.DATE];
    datePartsString = datePartsString.replace(_types.DatePartFormatMap[_types.DatePartEnum.YEAR], (year != null ? year.toString() : '').padStart(_types.DatePartFormatMap[_types.DatePartEnum.YEAR].length, placeholder));
    datePartsString = datePartsString.replace(_types.DatePartFormatMap[_types.DatePartEnum.MONTH], (month != null ? (month + 1).toString() : '').padStart(_types.DatePartFormatMap[_types.DatePartEnum.MONTH].length, placeholder));
    datePartsString = datePartsString.replace(_types.DatePartFormatMap[_types.DatePartEnum.DATE], (date != null ? date.toString() : '').padStart(_types.DatePartFormatMap[_types.DatePartEnum.DATE].length, placeholder));
    return datePartsString;
  });

  _defineProperty(this, "toLocaleString", function () {
    var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
    var locale = arguments.length > 1 ? arguments[1] : undefined;
    return _this.toString((0, _utils.getLocaleDateFormat)(placeholder, locale).formatString, placeholder);
  });

  _defineProperty(this, "toISOString", function (hours, minutes, seconds, timezoneModifier) {
    if (!_this.isFullDate()) return null;

    var isoString = _this.toString("".concat(_types.DatePartFormatMap[_types.DatePartEnum.YEAR], "-") + "".concat(_types.DatePartFormatMap[_types.DatePartEnum.MONTH], "-") + "".concat(_types.DatePartFormatMap[_types.DatePartEnum.DATE]), '0');

    if (hours == null) return isoString;
    isoString += "T".concat(hours);
    if (minutes == null) return isoString;
    isoString += ":".concat(minutes);
    if (seconds == null) return isoString;
    isoString += ":".concat(seconds);
    if (timezoneModifier == null) return isoString;
    isoString += timezoneModifier;
    return isoString;
  });

  _defineProperty(this, "toDate", function () {
    var hours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (!_this.isFullDate()) return null;
    return new Date(_this[_types.DatePartEnum.YEAR] || 0, _this[_types.DatePartEnum.MONTH] || 0, _this[_types.DatePartEnum.DATE] || 0, hours, minutes, seconds);
  });

  _defineProperty(this, "toUTCDate", function () {
    var hours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (!_this.isFullDate()) return null;

    var isoString = _this.toISOString(hours, minutes, seconds, 'Z');

    if (!isoString) return null;
    return new Date(isoString);
  });

  _defineProperty(this, "isFullDate", function () {
    return !!(_this[_types.DatePartEnum.DATE] != null && _this[_types.DatePartEnum.MONTH] != null && _this[_types.DatePartEnum.YEAR] != null);
  });

  _defineProperty(this, "isCurrentDate", function () {
    return _this.isEqualTo(DateParts.now());
  });

  _defineProperty(this, "isCurrentUTCDate", function () {
    return _this.isEqualTo(DateParts.utcNow());
  });

  _defineProperty(this, "cap", function () {
    var maxYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9999;
    var minYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var uncappedYear = _this[_types.DatePartEnum.YEAR];

    if (uncappedYear != null) {
      _this[_types.DatePartEnum.YEAR] = Math.max(Math.min(uncappedYear, maxYear), minYear);
    }

    var uncappedMonth = _this[_types.DatePartEnum.MONTH];

    if (uncappedMonth != null) {
      _this[_types.DatePartEnum.MONTH] = Math.max(Math.min(uncappedMonth, 11), 0);
    }

    var uncappedDate = _this[_types.DatePartEnum.DATE];

    if (uncappedDate != null) {
      _this[_types.DatePartEnum.DATE] = Math.max(Math.min(uncappedDate, (0, _utils.getDaysInMonth)(_this[_types.DatePartEnum.MONTH] || 0, _this[_types.DatePartEnum.YEAR] || 0)), 1);
    }
  });

  this[_types.DatePartEnum.YEAR] = _year;
  this[_types.DatePartEnum.MONTH] = _month;
  this[_types.DatePartEnum.DATE] = _date;
}
/**
 * Create a DateParts object from a date using the standard parts functions.
 * ## WARNING: This will mean the date parts will be in the systems timezone.
 *
 * @param date - The date to convert to date parts
 */
; // #### HOOKS ####

/**
 * Custom hook that returns the current DateParts.
 *
 * @param keepAliveDelay - The period in ms used for updating the DateParts, 0 will cause the DateParts to be static. Default = 0;
 */


exports.DateParts = DateParts;

_defineProperty(DateParts, "fromDate", function (date) {
  date = new Date(date);
  return new DateParts(date.getFullYear(), date.getMonth(), date.getDate());
});

_defineProperty(DateParts, "fromDateUTC", function (date) {
  date = new Date(date);
  return new DateParts(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
});

_defineProperty(DateParts, "now", function () {
  return DateParts.fromDate(new Date());
});

_defineProperty(DateParts, "utcNow", function () {
  return DateParts.fromDateUTC(new Date());
});

var useCurrentDateParts = function useCurrentDateParts() {
  var keepAlivePeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = (0, _react.useState)(DateParts.now()),
      _useState2 = _slicedToArray(_useState, 2),
      dateParts = _useState2[0],
      setDateParts = _useState2[1];

  (0, _react.useEffect)(function () {
    if (keepAlivePeriod) {
      var interval = setInterval(function () {
        return setDateParts(DateParts.now());
      }, keepAlivePeriod);
      return clearInterval(interval);
    }
  }, [keepAlivePeriod]);
  return dateParts;
};
/**
 * Custom hook that returns the current DateParts for UTC.
 *
 * @param keepAliveDelay - The period in ms used for updating the DateParts, 0 will cause the DateParts to be static. Default = 0;
 */


exports.useCurrentDateParts = useCurrentDateParts;

var useCurrentDatePartsUTC = function useCurrentDatePartsUTC() {
  var keepAlivePeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState3 = (0, _react.useState)(DateParts.utcNow()),
      _useState4 = _slicedToArray(_useState3, 2),
      dateParts = _useState4[0],
      setDateParts = _useState4[1];

  (0, _react.useEffect)(function () {
    if (keepAlivePeriod) {
      var interval = setInterval(function () {
        return setDateParts(DateParts.utcNow());
      }, keepAlivePeriod);
      return clearInterval(interval);
    }
  }, [keepAlivePeriod]);
  return dateParts;
};

exports.useCurrentDatePartsUTC = useCurrentDatePartsUTC;